import React, { useState, useEffect } from 'react';
import { Form, Input } from '@rocketseat/unform';
import { useDispatch, useSelector } from 'react-redux';
import { documentMaskPhone } from '~/util/documentInputMask';
import { Container, Loader } from './styles';

import {
  getDataProfileRequest,
  updateProfileRequest,
} from '~/store/modules/user/actions';

import { store } from '~/store';

export default function MyAccount() {
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [residential, setResidential] = useState('');
  const [commercial, setCommercial] = useState('');
  const loading = useSelector(state => state.user.loading);

  useEffect(() => {
    const { token } = store.getState().auth;

    dispatch(getDataProfileRequest(token));
  }, [dispatch]);

  useEffect(() => {
    if (store.getState().user.data) {
      const { conteudo } = store.getState().user.data;
      if (conteudo) {
        setEmail(conteudo.email);
        setPhone((conteudo.celular instanceof Array ? conteudo.celular[0] : conteudo.celular));
        setResidential(conteudo.residencial);
        setCommercial(conteudo.comercial);
      }
    }
  }, [loading]);

  async function handleSubmit(data) {
    const { token } = store.getState().auth;
    const { residencial, Email, celular, comercial } = data;

    const arrayData = [];

    if (residencial !== '') {
      arrayData.push({ IdTipoContato: 1, Contato: residencial });
      setResidential(residencial);
    }
    if (Email !== '') {
      arrayData.push({ IdTipoContato: 2, Contato: Email });
      setEmail(Email);
    }
    if (celular !== '') {
      arrayData.push({ IdTipoContato: 3, Contato: celular });
      setPhone(celular);
    }
    if (comercial !== '') {
      arrayData.push({ IdTipoContato: 4, Contato: comercial });
      setCommercial(comercial);
    }

    dispatch(updateProfileRequest(token, arrayData));
  }

  return (
    <Container>
      <Loader style={{ display: loading ? 'block' : 'none' }} />
      <Form onSubmit={handleSubmit}>
        <h2>Minha Conta</h2>
        <div>E-mail</div>
        <Input
          maxLength="100"
          name="Email"
          placeholder="clienteapolar@email.com.br"
          value={email}
          onChange={e => {
            setEmail(e.target.value);
          }}
        />
        <div>Residencial</div>
        <Input
          maxLength="15"
          name="residencial"
          placeholder="(41) 3030-3030"
          value={residential}
          onChange={e => {
            setResidential(documentMaskPhone(e.target.value));
          }}
        />
        <div>Celular</div>
        <Input
          maxLength="15"
          name="celular"
          placeholder="(41) 99898-0077"
          value={phone}
          onChange={e => {
            setPhone(documentMaskPhone(e.target.value));
          }}
        />
        <div>Comercial</div>
        <Input
          maxLength="15"
          name="comercial"
          placeholder="(41) 99898-0077"
          value={commercial}
          onChange={e => {
            setCommercial(documentMaskPhone(e.target.value));
          }}
        />

        <button type="submit">Salvar</button>
      </Form>
    </Container>
  );
}
